import ElementList from 'Admin/AccountMapperNew/components/ElementList'
import useElementNames from 'hooks/useElementNames'
import { useEffect, useState } from 'react'

const SpacesFilters = ({ sorElements, spaces, initialFilters, setSelectedFilters }) => {
  const elementNames = useElementNames()

  const [elements, setElements] = useState({
    elementList1: [],
    elementList2: [],
    elementList3: [],
    elementList4: []
  })

  const [filters, setFilters] = useState({
    element1: '',
    element2: '',
    element3: '',
    element4: ''
  })

  useEffect(() => {
    const { elementList1 } = sorElements || {}
    if (elementList1?.length) {
      const uniqueElement1 = [...new Set(spaces.map((space) => space.element1))].map((el) => ({ id: el, value: el }))
      const uniqueElement2 = [...new Set(spaces.map((space) => space.element2))].map((el) => ({
        id: el,
        value: el,
        element1Id: sorElements?.elementList2.find((e) => e.id === el).element1Id
      }))
      const uniqueElement3 = [...new Set(spaces.map((space) => space.element3))].map((el) => ({
        id: el,
        value: el,
        element2Id: sorElements?.elementList3.find((e) => e.id === el).element2Id
      }))
      const uniqueElement4 = [...new Set(spaces.map((space) => space.element4))].map((el) => ({
        id: el,
        value: el,
        element3Id: sorElements?.elementList4.find((e) => e.id === el).element3Id
      }))

      setElements({
        elementList1: uniqueElement1,
        elementList2: uniqueElement2,
        elementList3: uniqueElement3,
        elementList4: uniqueElement4
      })
    }
  }, [spaces, sorElements])

  useEffect(() => {
    if (initialFilters) {
      setFilters({
        ...initialFilters
      })
    }
  }, [initialFilters])

  useEffect(() => {
    setSelectedFilters(filters)
    localStorage.setItem('initialFilters', JSON.stringify(filters))
  }, [filters])

  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th>{elementNames?.element1}</th>
          <th>{elementNames?.element2}</th>
          <th>{elementNames?.element3}</th>
          <th>{elementNames?.element4}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <ElementList
              elementType="element1"
              elements={elements.elementList1}
              onChange={(data) => {
                const element1ID = JSON.parse(data).id
                const element2ID = elements.elementList2.filter((el) => el.element1Id === element1ID)[0].id
                const element3ID = elements.elementList3.filter((el) => el.element2Id === element2ID)[0].id
                const element4ID = elements.elementList4.filter((el) => el.element3Id === element3ID)[0].id

                setFilters({
                  ...filters,
                  element1: element1ID,
                  element2: element2ID,
                  element3: element3ID,
                  element4: element4ID
                })
              }}
              dropDownLabel={filters.element1 || 'please select'}
            />
          </td>
          <td>
            <ElementList
              elementType="element2"
              elements={elements.elementList2.filter((el) => el.element1Id === filters.element1)}
              onChange={(data) => {
                const element2ID = JSON.parse(data).id
                const element3ID = elements.elementList3.filter((el) => el.element2Id === element2ID)[0].id
                const element4ID = elements.elementList4.filter((el) => el.element3Id === element3ID)[0].id
                setFilters({ ...filters, element2: element2ID, element3: element3ID, element4: element4ID })
              }}
              dropDownLabel={filters.element2 || 'please select'}
            />
          </td>
          <td>
            <ElementList
              elementType="element3"
              elements={elements.elementList3.filter((el) => el.element2Id === filters.element2)}
              onChange={(data) => {
                const element3ID = JSON.parse(data).id
                const element4ID = elements.elementList4.filter((el) => el.element3Id === element3ID)[0].id
                setFilters({ ...filters, element3: element3ID, element4: element4ID })
              }}
              dropDownLabel={filters.element3 || 'please select'}
            />
          </td>
          <td>
            <ElementList
              elementType="element4"
              elements={elements.elementList4.filter((el) => el.element3Id === filters.element3)}
              onChange={(data) => {
                const element4ID = JSON.parse(data).id
                setFilters({ ...filters, element4: element4ID })
              }}
              dropDownLabel={filters.element4 || 'please select'}
            />
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default SpacesFilters
